import { toast } from "react-toastify";

const MB = 1024 * 1024;

// Mirrors the api, which enforces these limits: the selfie is held lower
// because it goes as-is to Azure Face.
export const MAX_DOCUMENT_BYTES = 10 * MB;
export const MAX_SELFIE_BYTES = 5 * MB;

export const formatMaxSize = (maxBytes) => `${maxBytes / MB}Mo`;

/**
 * Stops an oversized file at selection time, rather than letting the upload
 * fail with a generic error. Like the api, a file reaching the limit is refused.
 * Returns true when the file was rejected, so the caller keeps its state as is.
 */
export const rejectFileIfTooLarge = (event, maxBytes = MAX_DOCUMENT_BYTES) => {
  const file = event?.target?.files?.[0];
  if (!file || file.size < maxBytes) return false;

  toast.error(
    `Le fichier « ${file.name} » dépasse la taille maximale de ${formatMaxSize(maxBytes)}.`
  );
  // Cleared so that choosing the same file again still fires onChange.
  event.target.value = "";
  return true;
};
